import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { fonts } from "../../../styles/variables";

const Container = styled.div`
  height: 100%;
  width: 100%;
  background-color: transparent;
  align-items: flex-start;
  justify-content: center;
  cursor: default;
`;

const MessageContent = styled.span`
  cursor: default;
`;

const ClickableMessageContent = styled(MessageContent)`
  font-family: ${(props) => props.clickableFontFamily || fonts.fontInterstateUltraBlack};
  text-transform: ${(props) => (props.isUppercase ? "uppercase" : "none")};
  cursor: pointer;
  letter-spacing: ${(props) =>
    props.clickableFontFamily === fonts.fontInterstateUltraBlack ? "1.4px" : "normal"};
`;

const ClickableMessageText = styled.h6`
  font-family: ${(props) => props.clickableFontFamily || fonts.fontInterstateUltraBlack};
  font-size: 11px;
  cursor: pointer;
  text-transform: ${(props) => (props.isUppercase ? "uppercase" : "none")};
  letter-spacing: ${(props) =>
    props.clickableFontFamily === fonts.fontInterstateUltraBlack ? "1.4px" : "normal"};
  padding-top: 3px;
`;

const CustomAlert = ({
  onClick,
  message,
  clickableMsg,
  clickableMsgInNewLine = false,
  clickableFontFamily = fonts.fontInterstateUltraBlack,
  isClickableUppercase = false,
}) => (
  <Container>
    <MessageContent>{message}</MessageContent>
    {!!clickableMsg && !clickableMsgInNewLine && (
      <ClickableMessageContent
        onClick={() => onClick && onClick()}
        clickableFontFamily={clickableFontFamily}
        isUppercase={isClickableUppercase}
      >
        {clickableMsg}
      </ClickableMessageContent>
    )}
    {!!clickableMsg && clickableMsgInNewLine && (
      <ClickableMessageText
        onClick={() => onClick && onClick()}
        clickableFontFamily={clickableFontFamily}
        isUppercase={isClickableUppercase}
      >
        {clickableMsg}
      </ClickableMessageText>
    )}
  </Container>
);

CustomAlert.propTypes = {
  onClick: PropTypes.func,
  message: PropTypes.string.isRequired,
  clickableMsg: PropTypes.string,
  clickableMsgInNewLine: PropTypes.bool,
  clickableFontFamily: PropTypes.string,
  isClickableUppercase: PropTypes.bool,
};

export default CustomAlert;
